import { render, staticRenderFns } from "./CmStageService.vue?vue&type=template&id=07cb9b4f"
import script from "./CmStageService.vue?vue&type=script&lang=ts"
export * from "./CmStageService.vue?vue&type=script&lang=ts"
import style0 from "./CmStageService.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Headline: require('/app/components/base/Headline/Headline.vue').default,VideoComponent: require('/app/components/base/VideoComponent/VideoComponent.vue').default,ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default,CmAbstract: require('/app/components/modules/CmAbstract/CmAbstract.vue').default,ContactItem: require('/app/components/base/ContactItem/ContactItem.vue').default,Alert: require('/app/components/app/Alert/Alert.vue').default})
